import React, { useState } from 'react';
import { TabContext, TabList } from '@mui/lab';
import { Box, Tab } from "@mui/material";
import { CustomerDetails, ProductDetails } from "./Blocks";


export const ListTable = (props) => {
  const { classes, loadMore, customerList, productList } = props;
  const [value, setValue] = useState('customer-details');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <Box className={classes.tabDesign}>
        <TabList onChange={handleChange}>
          <Tab disabled={loadMore} className={classes.Bordertab_1} label="Customer Details" value={'customer-details'} />
          <Tab className={classes.Bordertab_2} disabled={loadMore}
            label="Product Details" value={'product-details'} />
        </TabList>
      </Box>
      {
        value === 'customer-details' ?
          <CustomerDetails {...props} details={customerList} /> :
          <ProductDetails  {...props} details={productList} />
      }
    </TabContext>
  )
}